import type { FaireProductEntity } from "../../entity_types/product";

export const p_ujzaavgebn: FaireProductEntity = {
  token: "p_ujzaavgebn",
  type: "product",
  name: "Mini Nantucket Hydrangeas (10 Pop-up Greeting Cards)",
  brandToken: "b_5ng28zx6sc",
  brandName: "FreshCut Paper LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/d90439b1121783fbe5570b9f436c6d281addc5e5ab8d82c6cc5189db1de63593.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2af33408f3c0521b6c19369551a9548b24669797183873b6e2c26106ff7852a9.jpeg",
    "https://cdn.faire.com/fastly/e5f3d70d84a4d160234407cc95ddea8e8aba26ff333e420ed86d4739dbd82330.jpeg",
    "https://cdn.faire.com/fastly/68ed6d8b67dddfffd0bdd0f417cea898f979f5f95ca95a4ec5fd3f7f2ea62a48.jpeg",
    "https://cdn.faire.com/fastly/6c183f3b1a6216feed5f31e07e2af732ecac5ecbb1fe84698f914032ebbb0acd.jpeg",
    "https://cdn.faire.com/fastly/00e6ded4041144d3399f371cda54f302d6384db593824c154da8edbfc27fdbc8.jpeg",
    "https://cdn.faire.com/fastly/42c76f342c77b08ebc4ab5716660ec64fdc8e402706cfa20acbc07227c77ce89.jpeg",
    "https://cdn.faire.com/fastly/6e834e095b6e3c58d3a05935f57aab9105c71b6df596c6aeab53710079ff1826.jpeg",
  ],
  priceDollars: 3.5,
  description:
    "Nantucket Hydrangeas (10 Bouquets with envelope, notecard).\n\n𝐈𝐧𝐜𝐥𝐮𝐝𝐞𝐬:\n• pop up bouquet, matching note card and vibrant mailing envelope\n\nSamples available to purchase.\n\nSynonymous with the sea breeze of Nantucket, FreshCut Paper’s Mini Hydrangea features delicate blossoms in shades of cerulean, indigo, and powder blue in powerful yet pocket sized style. Add a pop of New England preppy with this pop-up bouquet for instant elegance. Send these hydrangea hues as a timeless thank you, and give the gift of tranquility.\n\nPerfect for Fathers Day!",
  tags: [],
  msrpDollars: 7.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:07.943Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
